
const states = {
  userdata: null,
  locale: null,
  notifications: [],
  totalNotif: 0
}

export default states
  